<template>
  <div>
    <div class="delete-tip">
      <i class="el-icon-info delete-tip-icon"></i
      >若删除账期，其他账期的起止日等信息不变
    </div>
    <div class="dialog-operate">
      <el-button
        :disabled="tableDataFrom.tableData && !tableDataFrom.tableData.length"
        class="dialog-add-btn"
        @click="handleAdd"
      >
        新增期数
      </el-button>
      <div class="dialog-date-range">
        <span>收款起止日期：</span>
        <span>{{ `${startStopDate[0]} 至 ${startStopDate[1]}` }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { debounce } from '@/utils'
import { getNextDate } from '../calculator'

export default {
  name: 'PreviewRentOrderHeader',
  data() {
    return {}
  },
  props: {
    payMode: {
      type: [String, Number],
      default: '',
    },
    planAmount: {
      type: [String, Number],
      default: '',
    },
    payDay: {
      type: [String, Number],
      default: '',
    },
    payPost: {
      type: [String, Number],
      default: 0,
    },
    tableDataFrom: {
      type: Object,
      default() {
        return {}
      },
    },
    startStopDate: {
      type: Array,
      default() {
        return []
      },
    },
  },
  methods: {
    // 添加条目
    handleAdd: debounce(function () {
      const { tableDataFrom, planAmount, payDay, payMode, payPost } = this
      const row = { payMode, payDay, payPost, tableDataFrom }
      const num = tableDataFrom.tableData.length
      tableDataFrom.tableData.push({
        num: num + 1,
        accruedCycle: getNextDate(row).accruedCycle,
        dueDate: getNextDate(row).dueDate,
        remarks: '',
        planAmount,
      })
    }, 300),
  },
}
</script>

<style lang="scss" scoped>
.delete-tip {
  height: 22px;
  background-color: #ecf3ff;
  color: #323233;
  font-size: 14px;
  height: 32px;
  display: flex;
  align-items: center;
  border-radius: 2px;
  margin-bottom: 8px;
  border: 1px solid #b1cfff;
  &-icon {
    margin: 0 9px 0 17px;
    color: #2e7eff;
  }
}
.dialog-operate {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  .dialog-date-range {
    display: flex;
    height: 20px;
    align-items: center;
    span {
      font-size: 14px;
      color: #323233;
    }
    span:nth-child(1) {
      color: #969799;
    }
  }
  .dialog-add-btn {
    font-size: 14px;
    color: #323233;
    border: 1px solid #dcdee0;
  }
}
</style>
